import type { Hotel } from '../types';

/**
 * Generate a URL-safe slug from a hotel name.
 * "Limak Lara De Luxe Hotel & Resort" → "limak-lara-de-luxe-hotel-resort"
 */
export const generateHotelSlug = (name: string): string => {
    if (!name) return '';
    return name
        .toLowerCase()
        .replace(/[&]/g, 'and')
        .replace(/[ğ]/g, 'g')
        .replace(/[ü]/g, 'u')
        .replace(/[ş]/g, 's')
        .replace(/[ı]/g, 'i')
        .replace(/[ö]/g, 'o')
        .replace(/[ç]/g, 'c')
        .replace(/[åä]/g, 'a')
        .replace(/[é]/g, 'e')
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
};

/**
 * Generate a destination slug from city name.
 * "Antalya" → "antalya", "Bodrum" → "bodrum"
 */
export const generateDestinationSlug = (city: string): string => {
    if (!city) return 'hotel';
    return generateHotelSlug(city);
};

/**
 * Generate a full SEO-friendly hotel URL path.
 * Returns "/:destination/:hotel-slug" format.
 * Includes hotel ID as a query param for resolution.
 */
export const generateHotelPath = (hotel: Hotel): string => {
    const city = hotel.location?.city || '';
    const destSlug = generateDestinationSlug(city);
    const hotelSlug = generateHotelSlug(hotel.name);

    if (!hotelSlug) return `/hotel/${hotel.id}`;

    return `/hotel/${destSlug}/${hotelSlug}`;
};
